import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG } from '@boma/app-config';
import {
  IPaginatedResponse,
  IRole,
  IUser,
  IUsers,
} from '@boma/administration-portal/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class UsersService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listUsers(queryText: string = '', skipToken: string = '') {
    return this.httpClient.get<IPaginatedResponse<IUser>>(
      `${this.base}api/v${this.version}/Users`,
      {
        params: { queryText, skipToken},
      }
    );
  }

  loadUserDetails(id: string) {
    return this.httpClient.get<IUser>(
      `${this.base}api/v${this.version}/Users/${id}`
    );
  }

  searchUsers(queryText: string) {
    return this.httpClient.get<IPaginatedResponse<IUser>>(
      `${this.base}api/v${this.version}/Users`,
      {
        params: { queryText },
      }
    );
  }

  addRoleUser(role: IRole, userId: string) {
    return this.httpClient.post<IUser>(
      `${this.base}api/v${this.version}/Users/${userId}/roles`,
      {
        roleId: role.id,
      }
    );
  }

  removeRoleUser(roleId: string, userId: string) {
    return this.httpClient.delete<IUser>(
      `${this.base}api/v${this.version}/Users/${userId}/roles/${roleId}`
    );
  }
}
